import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { Converter } from '../shared';
import { PackageType, UpdatePackage } from '../models';
import { BaseService } from './base-service';

@Injectable()
export class SoftwareInventoryService implements BaseService<UpdatePackage> {
    private static FILE_FORM_PROPERTY = 'file';
    private static TYPE_FORM_PROPERTY = 'type';
    private static VERSION_FORM_PROPERTY = 'version';
    private static TAG_FORM_PROPERTY = 'tag';

    private resourceUrl = 'api/updates';

    constructor(private http: Http) {
    }

    private encodeString(url: string): string {
        // encode also dot '.' and '-'
        return encodeURIComponent(url)
                .replace(/\./g, '%2E')
                .replace(/\-/g, '%2D');
    }

    upload(updatePackage: File, type: PackageType, version: string, tag: string): Observable<UpdatePackage> {
        const body = new FormData();

        if (updatePackage) {
            body.append(SoftwareInventoryService.FILE_FORM_PROPERTY, updatePackage);
        }
        if (type) {
            body.append(SoftwareInventoryService.TYPE_FORM_PROPERTY, type);
        }
        if (version) {
            body.append(SoftwareInventoryService.VERSION_FORM_PROPERTY, this.encodeString(version));
        }
        if (tag) {
            body.append(SoftwareInventoryService.TAG_FORM_PROPERTY, this.encodeString(tag));
        }

        return this.http.post(this.resourceUrl, body).map((response: Response) => {
            return Converter.fromJson(UpdatePackage, response.json());
        });
    }

    find(filename: string): Observable<UpdatePackage> {
        const escapedName: string = this.encodeString(filename);
        return this.http.get(`${this.resourceUrl}/${escapedName}`).map((response: Response) => {
            return Converter.fromJson(UpdatePackage, response.json());
        });
    }

    all(): Observable<Array<UpdatePackage>> {
        return this.http.get(this.resourceUrl).map((response: Response) => {
            return Converter.fromJsonArray(UpdatePackage, response.json());
        });
    }

    delete(filename: string): Observable<Response> {
        const escapedName: string = this.encodeString(filename);
        return this.http.delete(`${this.resourceUrl}/${escapedName}`);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/software-inventory.service.ts